"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'salesPerformanceStore',
      searchQuery: {
        regionCode: '',
        cityCode: '',
        // srEmpNo: "",
        srEmpName: ''
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        // srEmpNo: {
        //   label: this.$t("sfe.salesPerformance.srEmpNo"),
        //   valueKey: "srEmpNo"
        // },
        srEmpName: {
          label: this.$t('sfe.salesPerformance.srEmpName'),
          valueKey: 'srEmpName'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.salesperformancestore'),
          apiUrl: '/protected/pc/report/store/salePerformance/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        district: {
          label: this.$t('sfe.salesPerformance.district'),
          fixed: 'left'
        },
        storeCode: {
          label: this.$t('sfe.salesPerformance.storeCode'),
          fixed: 'left'
        },
        storeName: {
          label: this.$t('sfe.salesPerformance.storeName'),
          fixed: 'left'
        },
        empName: {
          label: this.$t('sfe.salesPerformance.empName'),
          fixed: 'left'
        },
        retailerType: {
          label: this.$t('sfe.salesPerformance.retailerType')
        },
        storeType: {
          label: this.$t('sfe.salesPerformance.storeType')
        },
        tppQty: {
          label: this.$t('sfe.salesPerformance.tppQty')
        },
        saleQty: {
          label: this.$t('sfe.salesPerformance.saleQty')
        },
        actualEighteenQty: {
          label: this.$t('sfe.salesPerformance.actualEighteenQty')
        },
        luxQty: {
          label: this.$t('sfe.salesPerformance.luxQty')
        },
        suvQty: {
          label: this.$t('sfe.salesPerformance.suvQty')
        },
        evQty: {
          label: this.$t('sfe.salesPerformance.evQty')
        },
        // atcQty: {
        //   label: this.$t('sfe.salesPerformance.atcQty')
        // },
        // amgQty: {
        //   label: this.$t('sfe.salesPerformance.amgQty')
        // },
        // a6Qty: {
        //   label: this.$t('sfe.salesPerformance.a6Qty')
        // },
        newProduct1Qty: {
          label: this.$t('sfe.salesPerformance.newProduct1Qty')
        },
        newProduct2Qty: {
          label: this.$t('sfe.salesPerformance.newProduct2Qty')
        },
        newProduct3Qty: {
          label: this.$t('sfe.salesPerformance.newProduct3Qty')
        },
        newProduct4Qty: {
          label: this.$t('sfe.salesPerformance.newProduct4Qty')
        },
        warrantyQty: {
          label: this.$t('sfe.salesPerformance.warrantyQty')
        },
        salesIntegral: {
          label: this.$t('sfe.salesPerformance.salesIntegral')
        },
        totalSaleQty: {
          label: this.$t('sfe.salesPerformance.totalSaleQty')
        },
        m1SaleQty: {
          label: this.$t('sfe.salesPerformance.m1SaleQty')
        },
        m2SaleQty: {
          label: this.$t('sfe.salesPerformance.m2SaleQty')
        },
        m3SaleQty: {
          label: this.$t('sfe.salesPerformance.m3SaleQty')
        },
        m4SaleQty: {
          label: this.$t('sfe.salesPerformance.m4SaleQty')
        },
        m5SaleQty: {
          label: this.$t('sfe.salesPerformance.m5SaleQty')
        },
        m6SaleQty: {
          label: this.$t('sfe.salesPerformance.m6SaleQty')
        },
        m7SaleQty: {
          label: this.$t('sfe.salesPerformance.m7SaleQty')
        },
        m8SaleQty: {
          label: this.$t('sfe.salesPerformance.m8SaleQty')
        },
        m9SaleQty: {
          label: this.$t('sfe.salesPerformance.m9SaleQty')
        },
        m10SaleQty: {
          label: this.$t('sfe.salesPerformance.m10SaleQty')
        },
        m11SaleQty: {
          label: this.$t('sfe.salesPerformance.m11SaleQty')
        },
        m12SaleQty: {
          label: this.$t('sfe.salesPerformance.m12SaleQty')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/app/store/report/sales/performance'
      };
    }
  },
  created: function created() {
    this.searchQuery.regionCode = this.$route.query.regionCode || '';
    this.searchQuery.cityCode = this.$route.query.cityCode || '';
  }
};